import React from 'react';
import {
  flagLabel,
  type VerificationFlag,
  type VerificationScore,
} from '../../../../../../shared/lib/verification';
import { StatusBadge, type StatusTone } from '../../../../components/ui';

// ---------------------------------------------------------------------------
// FORGE-228 — verification-confidence surfaces (loop-engineering costs)
// #4 proof-strength meter badges, shared by StoryCard and ReviewAttentionCard.
// ---------------------------------------------------------------------------

const BAND_TONE: Record<'strong' | 'partial' | 'weak', StatusTone> = {
  strong: 'success',
  partial: 'warning',
  weak: 'danger',
};

function gateTitle(v: VerificationScore): string {
  return v.gates
    .filter((g) => g.status !== 'na')
    .map((g) => `${g.label}: ${g.status}`)
    .join(' · ');
}

/** #4 — compact proof-strength badge; hidden while pending / not applicable. */
export const VerificationBadge: React.FC<{ v: VerificationScore }> = ({ v }) => {
  if (v.score === null || v.band === 'pending' || v.band === 'na') return null;
  return (
    <span title={gateTitle(v)} data-testid="verification-badge">
      <StatusBadge tone={BAND_TONE[v.band]}>{v.score}% verified</StatusBadge>
    </span>
  );
};

const FLAG_TONE: Record<VerificationFlag, StatusTone> = {
  unreviewed: 'danger',
  not_verified: 'danger',
  churned: 'warning',
  large: 'neutral',
  force_settled: 'warning',
};
const FLAG_SHORT: Record<VerificationFlag, string> = {
  unreviewed: 'unreviewed',
  not_verified: 'not verified',
  churned: 'churned',
  large: 'large',
  force_settled: 'force-settled',
};

export const FlagChip: React.FC<{ flag: VerificationFlag }> = ({ flag }) => (
  <span title={flagLabel(flag)}>
    <StatusBadge tone={FLAG_TONE[flag]}>{FLAG_SHORT[flag]}</StatusBadge>
  </span>
);
